var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import EmailMetricDomainService from "../Domain/EmailMetric/EmailMetric.service";
const BASE_URL = "/aviso/trackedMessage/";
// const getLastRollingCounts = (
//   messageSourceTypeId: number,
//   messageSourceIntId: ?number,
//   messageSourceUuidId: ?string,
//   startDate: number,
//   endDate: number,
//   listAll: boolean = false
// ): Promise<CampaignEmailTimespanMetric[]> =>
//   FetchService.get(BASE_URL + "getLastCountsForSourceAndSourceType", {
//     messageSourceTypeId,
//     messageSourceIntId,
//     messageSourceUuidId,
//     startDate,
//     endDate,
//     listAll,
//   });
export default class TrackedMessageService {
    static getOverallEventCountsForSourceType(messageSourceTypeId, startDate, endDate) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield FetchService.getSingleResponse(BASE_URL + "getOverallEventCounts", {
                messageSourceTypeId,
            });
            return [
                response || EmailMetricDomainService.createEmptyAggregate(),
                EmailMetricDomainService.createEmptyAggregate(),
            ];
        });
    }
    static getEventCountsForSource(messageSourceTypeId, messageSourceId, search = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const messageSourceIntId = typeof messageSourceId === "string" ? null : messageSourceId;
            const messageSourceUuidId = typeof messageSourceId === "string" ? messageSourceId : null;
            const response = yield FetchService.getSingleResponse(BASE_URL + "getEventCountsForSource", {
                messageSourceTypeId,
                messageSourceIntId,
                messageSourceUuidId,
                startDate: search.startDate,
                endDate: search.endDate,
            });
            if (response) {
                return EmailMetricDomainService.emailMetricsForSourceFromJSON(response);
            }
            return EmailMetricDomainService.createEmptyForSource();
        });
    }
    static getInfoForSourceAndSourceType(messageSourceTypeId, messageSourceIntId, messageSourceUuidId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.get(BASE_URL + "getSourceInfo", {
                messageSourceTypeId,
                messageSourceIntId,
                messageSourceUuidId,
            });
        });
    }
    // static getCountsOverTimeForSourceAndSourceType(
    //   messageSourceTypeId: number,
    //   messageSourceIntId?: number,
    //   messageSourceUuidId?: string,
    //   startDate: number,
    //   endDate: number
    // ): Promise<CampaignEmailTimespanMetric[]> {
    //   return FetchService.get(BASE_URL + "getCountsOverTimeForSource", {
    //     messageSourceTypeId,
    //     messageSourceIntId,
    //     messageSourceUuidId,
    //     startDate,
    //     endDate,
    //   });
    // }
    // prettier-ignore
    static getAggregatedByDayEmailMetrics() {
        return FetchService.getSingleResponse(BASE_URL + "getCountsOverTimeForSource");
    }
    static getEventCountsForSources(messageSourceTypeId, startDate, endDate, pageOptions = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield FetchService.getPagedResponse(BASE_URL + "getEventCountsForSources", {
                messageSourceTypeId,
                startDate,
                endDate,
                max: pageOptions.max,
                offset: pageOptions.offset,
                sort: pageOptions.sort,
                order: pageOptions.order,
            });
            return Object.assign(Object.assign({}, result), { data: (_a = result.data) === null || _a === void 0 ? void 0 : _a.map(EmailMetricDomainService.emailMetricsForSourceFromJSON) });
        });
    }
    // static async getLastRollingCountsPerEmail(
    //   messageSourceTypeId: number,
    //   startDate: number,
    //   endDate: number
    // ): Promise<CampaignEmailTimespanMetric[]> {
    //   return getLastRollingCounts(
    //     messageSourceTypeId,
    //     null,
    //     null,
    //     startDate,
    //     endDate,
    //     true
    //   );
    // }
    // static async getOverallRollingCountsForSourceType(
    //   messageSourceTypeId: number,
    //   startDate: number,
    //   endDate: number
    // ): Promise<CampaignEmailTimespanMetric[]> {
    //   const range = endDate - startDate;
    //
    //   const result = await Promise.all([
    //     getLastRollingCounts(messageSourceTypeId, null, null, startDate, endDate),
    //     getLastRollingCounts(
    //       messageSourceTypeId,
    //       null,
    //       null,
    //       startDate - range,
    //       endDate - range
    //     ),
    //   ]);
    //
    //   return [
    //     result[0][0] || CampaignEmailTimespanMetricDomainService.createEmpty(),
    //     result[1][0] || CampaignEmailTimespanMetricDomainService.createEmpty(),
    //   ];
    // }
    // static getRecipientsForSource(
    //   messageSourceTypeId: number,
    //   messageSourceIntId?: number,
    //   messageSourceUuidId?: string
    // ): Promise<CampaignEmailRecipient> {
    //   return FetchService.get(BASE_URL + "recipientsForSource", {
    //     messageSourceTypeId,
    //     messageSourceIntId,
    //     messageSourceUuidId,
    //   });
    // }
    static getRate(numerator, denominator, precision = 2) {
        const rate = denominator ? (numerator / denominator) * 100 : 0;
        return (rate.toFixed(precision) || 0) + "%";
    }
}
